var render = function () {
  var _vm$data, _vm$data$template;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: ['gg-section', ("gg-section_" + (_vm.project)), {
      'gg-section_disable': _vm.disable
    }]
  }, [_c((_vm$data = _vm.data) === null || _vm$data === void 0 ? void 0 : (_vm$data$template = _vm$data.template) === null || _vm$data$template === void 0 ? void 0 : _vm$data$template.component, {
    tag: "component",
    attrs: {
      "data": _vm.data,
      "user-cart": _vm.userCart,
      "preview": _vm.preview,
      "meta": _vm.meta
    },
    on: {
      "cart-add": function ($event) {
        return _vm.$emit('cart-add', $event);
      },
      "cart-remove": function ($event) {
        return _vm.$emit('cart-remove', $event);
      },
      "auth-needed": function ($event) {
        return _vm.$emit('auth-needed');
      }
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }